import * as React from 'react';
import { Editor, EditorTools } from '@progress/kendo-react-editor';
import '@progress/kendo-theme-default/dist/all.css';

const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    ForeColor,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    FormatBlock,
    Link,
    Unlink,
    InsertImage,
    ViewHtml,
    InsertTable,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    MergeCells,
    SplitCell
} = EditorTools;

const KendoReactEditor = React.forwardRef((props, ref) => {
    const { html, handleChange } = props;
    const [value, setValue] = React.useState(html);

    React.useImperativeHandle(ref, () => ({
        ResetChanges() {
            console.log('Hizo reset');
            setValue(html);
        },
        AcceptChanges() {
            handleChange(value);
        }
    }));

    const OnChange = (data) => {
        const { html } = data;
        setValue(html);
    };

    return (
        <Editor
            tools={[
                [Bold, Italic, Underline, Strikethrough],
                [Subscript, Superscript],
                [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                [Indent, Outdent],
                [OrderedList, UnorderedList],
                ForeColor,
                FontSize,
                FontName,
                FormatBlock,
                [Undo, Redo],
                [Link, Unlink, InsertImage, ViewHtml],
                [InsertTable],
                [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                [DeleteRow, DeleteColumn, DeleteTable],
                [MergeCells, SplitCell],
            ]}
            contentStyle={{ height: 630 }}
            value={value}
            onChange={OnChange}
        />
    );
})

KendoReactEditor.displayName = 'KendoReactEditor';
export default KendoReactEditor;
